import React from "react";
import { Modal, Form, Input } from "antd";

const { TextArea } = Input;

const ExcuseFormModal = ({ visible, onCancel, onSubmit, form, editingExcuse }) => {
  return (
    <Modal
      title={editingExcuse ? "Edit Excuse" : "Add New Excuse"}
      open={visible}
      onOk={onSubmit}
      onCancel={onCancel}
      okText={editingExcuse ? "Update" : "Create"}
      cancelText="Cancel"
      width={600}
      okButtonProps={{
        className: "bg-primary hover:bg-primary_hover",
      }}
    >
      <Form
        form={form}
        layout="vertical"
        className="mt-4"
      >
        <Form.Item
          name="name"
          label="Excuse Title"
          rules={[
            { required: true, message: "Please enter excuse title" },
            { max: 100, message: "Name cannot exceed 100 characters" },
          ]}
        >
          <Input
            placeholder="Enter excuse title"
            size="large"
            className="rounded-lg"
          />
        </Form.Item>

        <Form.Item
          name="description"
          label="Description"
          rules={[
            { max: 500, message: "Description cannot exceed 500 characters" },
          ]}
        >
          <TextArea
            placeholder="Enter excuse description (optional)"
            rows={4}
            size="large"
            className="rounded-lg"
            showCount
            maxLength={500}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ExcuseFormModal;